import { jsx as _jsx } from "react/jsx-runtime";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { Box, Chip } from "@mui/material";
import isEqual from "lodash.isequal";
import without from "lodash.without";
import React from "react";
import { Select } from "./Select.js";
export function SelectMultiple(props) {
    const { options, onChange } = props;
    const ref = React.useRef(null);
    const getChipLabel = (value) => {
        const option = options?.find(option => "groupTitle" in option ? false : isEqual(option.value, value));
        return option
            ? "groupTitle" in option
                ? undefined
                : option.label
            : undefined;
    };
    return (_jsx(Select, { ...props, inputRef: ref, multiple: true, renderValue: selected => {
            if (!selected)
                return null;
            return (_jsx(Box, { display: "flex", flexDirection: "row", alignItems: "baseline", flexWrap: "wrap", sx: { ml: -0.5, mt: -0.5 }, children: selected.map(value => (_jsx(Chip, { size: "small", clickable: false, variant: "outlined", label: getChipLabel(value), onDelete: !props.disabled
                        ? event => {
                            onChange(without(selected, value), event, null);
                        }
                        : undefined, deleteIcon: _jsx(CancelIcon, { onMouseDown: e => {
                            // prevent Select intercepting 'mousedown' event
                            e.stopPropagation();
                            e.preventDefault();
                            ref.current?.focus();
                        } }), sx: { ml: 0.5, mt: 0.25 } }, value))) }));
        } }));
}
//# sourceMappingURL=SelectMultiple.js.map